import {
    Compiler,
    Component,
    NgModule,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewContainerRef,
    ViewEncapsulation
} from '@angular/core';
import { ActivatedRoute, RouterModule } from "@angular/router";
import { Subscription } from "rxjs";
import { HighlightModule } from "ngx-highlightjs";
import { SharedModule } from "../../shared/shared.module";
import { Location, CommonModule } from "@angular/common";

@Component({
    selector: 'app-page',
    templateUrl: './page.component.html',
    styleUrls: ['./page.component.scss']
})
export class PageComponent implements OnInit, OnDestroy {

    @ViewChild('content', {read: ViewContainerRef, static: true}) content;

    private subscription: Subscription;

    constructor(
        private route: ActivatedRoute,
        private compiler: Compiler,
        private location: Location
    ) {
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe(params => {
            this.compileTemplate(`assets/pages/${params.page || 'home'}.html`);
        });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    private compileTemplate(templateUrl: string) {

        // Component metadata
        const metadata = {
            selector: 'ng-include',
            templateUrl,
            encapsulation: ViewEncapsulation.None
        };
        this.createComponentFactorySync(metadata);
    }

    private createComponentFactorySync(metadata: Component): void {

        // Ugly but best I can do atm
        let loc = this.location;

        const componentClass = class RuntimeComponent {
            public name: string = 'RuntimeComponent';
            public data = {};

            public navBack() {
                loc.back();
            }
        };
        const decoratedCmp = Component(metadata)(componentClass);
        @NgModule({imports: [HighlightModule, SharedModule, RouterModule, CommonModule], declarations: [decoratedCmp]})
        class RuntimeComponentModule {}

        this.compiler.compileModuleAndAllComponentsAsync(RuntimeComponentModule).then(module => {
            const factory = module.componentFactories.find(f => f.componentType === decoratedCmp);
            this.content.clear();
            this.content.createComponent(factory);
        });
    }
}
